const Wrapper=(props)=>{
    return(
        <main>
            <div className="width_100 ">			
                <div className="row">
                    <div className="width_100 ml-auto">
                        {props.children}
                    </div>
                </div>
            </div>
        </main>            
    )
}
export {Wrapper}